module.exports = __webpack_public_path__ + "static/media/yahoo.c9910a83.svg";